if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"ai_creative_scoring","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return false},
		rootOutputDir: "",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}